// Copyright (c) 2022-2024. Sendanor <info@sendanor.fi>. All rights reserved.

import {
    useCallback,
    useState,
} from "react";
import { EmailTokenDTO } from "../../../../../../../io/hyperify/core/auth/email/types/EmailTokenDTO";
import { SmsTokenDTO } from "../../../../../../../io/hyperify/core/auth/sms/types/SmsTokenDTO";
import { ButtonStyle } from "../../../../../../../io/hyperify/core/frontend/button/ButtonStyle";
import { LogService } from "../../../../../../../io/hyperify/core/LogService";
import { ClientDTO } from "../../../../../../../io/hyperify/core/store/types/client/ClientDTO";
import { IntegerField } from "../../../../../../../io/hyperify/frontend/components/fields/integer/IntegerField";
import { Form } from "../../../../../../../io/hyperify/frontend/components/form/Form";
import { SubmitButton } from "../../../../../../../io/hyperify/frontend/components/submitButton/SubmitButton";
import { AuthSessionService } from "../../../../../../../io/hyperify/frontend/services/AuthSessionService";
import { MY_SELECT_ANY_CLIENT_ARTICLE_CLASS_NAME } from "../../../../../core/constants/className";
import { SendanorClientHttpService } from "../../../../../core/services/SendanorClientHttpService";
import "./SelectAnyClientForm.scss";

const LOG = LogService.createLogger( 'SelectAnyClientForm' );

export function SelectAnyClientForm (
    props : {
        readonly className? : string;
        readonly selectAnyClientLabel : string;
        readonly selectClient : ( item : ClientDTO ) => void;
    },
) {
    const className = props?.className;
    const selectAnyClientLabel = props?.selectAnyClientLabel;
    const selectClient = props?.selectClient;

    const [ clientId, setClientId ] = useState<number | undefined>( undefined );

    const selectAnyClientCallback = useCallback(
        () => {
            const token : EmailTokenDTO | SmsTokenDTO | undefined = AuthSessionService.getToken();
            LOG.debug( `selectAnyClientCallback: token: ${token}`);
            if ( token && clientId !== undefined ) {
                LOG.debug( `selectAnyClientCallback: Fetching client data for: ${clientId}`);
                SendanorClientHttpService.getMyClientById( `${ clientId }`, token ).then( ( clientDto ) => {
                    if ( clientDto ) {
                        LOG.debug( `selectAnyClientCallback: Selected: ${clientId}: `, clientDto);
                        selectClient( clientDto );
                        setClientId(undefined);
                    } else {
                        LOG.error( `selectAnyClientCallback: Client not found: ${clientId}` );
                    }
                } ).catch( ( err : any ) => {
                    LOG.error( `selectAnyClientCallback: Could not select client ${ clientId }: `, err );
                } );
            } else {
                LOG.error( `selectAnyClientCallback: No access token or clientId defined` );
            }
        },
        [
            selectClient,
            clientId,
        ],
    );

    return (
        <Form
            className={
                MY_SELECT_ANY_CLIENT_ARTICLE_CLASS_NAME
                + (className ? ` ${ className }` : '')
            }
            submit={ selectAnyClientCallback }
        >
            <IntegerField
                placeholder={ '1234' }
                value={ clientId }
                change={ ( value : number | undefined ) => setClientId( value ) }
            />
            <SubmitButton
                style={ ButtonStyle.SECONDARY }
            >{ selectAnyClientLabel }</SubmitButton>
        </Form>
    );
}
